/**
 * SourceChip — every fact the car states carries a tappable source. This is
 * the trust contract that lets a conversational app stay "a place that holds
 * facts, not a personality".
 */
import type { ReactNode } from 'react';

export function SourceChip({ children, onClick }: { children: ReactNode; onClick?: () => void }) {
  const cls =
    'inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-kol-clay bg-kol-clay-soft rounded-[9px] px-2.5 py-1';
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cls}>
        {children}
      </button>
    );
  }
  return <span className={cls}>{children}</span>;
}
